import { render, staticRenderFns } from "./DepositRefundList.vue?vue&type=template&id=23a808ac&scoped=true"
import script from "./DepositRefundList.vue?vue&type=script&lang=js"
export * from "./DepositRefundList.vue?vue&type=script&lang=js"
import style0 from "./DepositRefundList.vue?vue&type=style&index=0&id=23a808ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a808ac",
  null
  
)

export default component.exports